import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw = {
  path: '/customer',
  name: 'Customer',
  component: () => import('@/views/organization/customer/index.vue'),
  meta: {
    title: '客户管理',
    icon: 'i-ant-design:contacts-outlined',
    auth: 'customer:list',
    singleMenu: true,
  },
}

export default routes
